export const NoStartDateMonthLimit = 4;
export const DateFlexibility = 14;
export const MaxBedroomCount = 8;
export const ShortRangeRentThreshold = 28;

export const MULTIUSE_START = '1500-01-01T00:00:00Z';
export const MULTIUSE_END = '2500-01-01T00:00:00Z';
